import React from 'react';

const SmileyFaceIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="13.5" fill="#FFCA47" stroke="#1a1a1a" strokeWidth="1.6"/>
        <rect x="11" y="12.5" width="2" height="3.4" rx="1" fill="#1a1a1a"/>
        <rect x="19" y="12.5" width="2" height="3.4" rx="1" fill="#1a1a1a"/>
        <path d="M11 19.5 Q16 24 21 19.5" stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
    </svg>
);

export default SmileyFaceIcon;